import { useRouter } from "next/router";

import { translate } from "@ascendnow/shared";

import AscButton from "../AscButton/AscButton";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscSelectInput from "../AscInputFields/AscSelectInput/AscSelectInput";

import { AscSurveyResultsHeaderProps } from "./AscSurveyResults.type";
import styles from "./AscSurveyResults.module.scss";

export function AscSurveyResultsHeader({
  title,
  pillars,
  skills,
  modules,
  response,
  onSubmit,
}: AscSurveyResultsHeaderProps) {
  const router = useRouter();

  const handleSelectHandler = (key: string, value: string) => {
    router.replace(
      {
        pathname: router.pathname,
        query: { ...router.query, [key]: value },
      },
      undefined,
      {
        shallow: true,
      }
    );
  };

  return (
    <header className={styles.header}>
      <AscHeading level={4} className={styles.title}>
        {title}
      </AscHeading>
      <div className={styles.filter}>
        <div className={styles.filterElementList}>
          <AscSelectInput
            multiple={false}
            placeholder={translate("pillarKey")}
            className={styles.filterElement}
            value={router.query.surveyPillar || ""}
            onChange={(value) =>
              handleSelectHandler("surveyPillar", value as string)
            }
            showArrowIcon
          >
            {pillars.map((c) => (
              <AscSelectInput.Option
                key={c.value}
                value={c.value}
                label={c.label}
              />
            ))}
          </AscSelectInput>
          <AscSelectInput
            multiple={false}
            placeholder={translate("skill")}
            className={styles.filterElement}
            value={router.query.surveySkill || ""}
            disabled={!router.query.surveyPillar}
            onChange={(value) =>
              handleSelectHandler("surveySkill", value as string)
            }
            showArrowIcon
          >
            {skills.map((c) => (
              <AscSelectInput.Option
                key={c.value}
                value={c.value}
                label={c.label}
              />
            ))}
          </AscSelectInput>
          <AscSelectInput
            multiple={false}
            placeholder={translate("module")}
            className={styles.filterElement}
            value={router.query.surveyModule || ""}
            disabled={!router.query.surveySkill}
            onChange={(value) =>
              handleSelectHandler("surveyModule", value as string)
            }
            showArrowIcon
          >
            {modules.map((c) => (
              <AscSelectInput.Option
                key={c.value}
                value={c.value}
                label={c.label}
              />
            ))}
          </AscSelectInput>
        </div>
        <AscButton className={styles.submitBtn} onClick={onSubmit}>
          {translate("submit")}
        </AscButton>
      </div>
      <div className={styles.responseStats}>
        <span className={styles.responseStatsLabel}>
          {translate("numberOfStudentResponses")}
        </span>
        <span className={styles.responseStatsValue}>
          {response.amount}/{response.total}
        </span>
      </div>
    </header>
  );
}
